import {
  LedgerRowClosing,
  LedgerRowContent,
  LedgerRowHeader,
  LedgerRowOpening,
} from '../ledger-row';
import {
  GetLedgerTrailBalanceSummaryResponse,
  PartyAccountBook,
} from '@zonofi/zono-money-store';
import { SpinnerLoader } from '@zonofi/seller-hub/components/spinner/spinner-loader';
import { ListSkeleton } from '@zonofi/seller-hub/components/list-skeleton';
import { PullRefreshContainer } from '@zonofi/seller-hub/components';
import './ledger-view.scss';
import moment from 'moment';

export interface LedgerViewProps {
  ledgerListData?: PartyAccountBook[];
  trialBalanceSummary?: GetLedgerTrailBalanceSummaryResponse;
  onScroll?: () => void;
  isEndOfList?: boolean;
  isLedgerListLoading?: boolean;
  isTrialBalanceSummaryLoading?: boolean;
  lastItemRef?: React.RefObject<HTMLDivElement>;
  creditLimit?: number;
}

export const LedgerView: React.FC<LedgerViewProps> = ({
  ledgerListData = [] as PartyAccountBook[],
  trialBalanceSummary = {} as GetLedgerTrailBalanceSummaryResponse,
  onScroll = () => {},
  isEndOfList = false,
  isLedgerListLoading = false,
  isTrialBalanceSummaryLoading = false,
  lastItemRef = null,
  creditLimit = 0,
}) => {
  return (
    <div className="ledger-view-container">
      <LedgerRowHeader rows={['Ledger', 'Debit', 'Credit']} />
      <LedgerRowOpening
        credit={creditLimit}
        debit={trialBalanceSummary?.openingBalance}
        date={
          moment(ledgerListData[0]?.transactionDate)?.format('Do MMM') ??
          moment(Date.now()).format('Do MMM')
        }
        isTrialBalanceLoading={isTrialBalanceSummaryLoading}
      />
      <div className="ledger-view-content-wrapper">
        {isLedgerListLoading ? (
          <ListSkeleton />
        ) : (
          <PullRefreshContainer
            className="ledger-view-content font-semibold font-primary-semibold"
            onScroll={onScroll}
          >
            {ledgerListData?.map((ledger) => (
              <LedgerRowContent
                date={moment(ledger?.transactionDate)?.format('Do MMM')}
                credit={ledger.creditAmount}
                debit={ledger.debitAmount}
                paymentId={ledger?.docNumber ?? ledger?.paymentId ?? ''}
                status={ledger.transactionTypeName ?? ''}
              />
            ))}
          </PullRefreshContainer>
        )}
        <div ref={lastItemRef} className="ledger-view-content-last-item" />
        {!isEndOfList && <SpinnerLoader />}
      </div>
      <LedgerRowClosing
        closingBalance={
          typeof trialBalanceSummary?.closingBalance === 'string'
            ? trialBalanceSummary?.closingBalance.slice(2)
            : trialBalanceSummary?.closingBalance
        }
        isTrialBalanceLoading={isTrialBalanceSummaryLoading}
      />
    </div>
  );
};
